
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Leagues from "../../modules/leagues/Leagues";
import { ModeIds } from "@chesshotel/constants";
export default Leagues;
export function getStaticPaths({ locales = [], }: {
    locales?: string[];
}) {
    const russianFallbackPaths = locales.includes("ru")
        ? [
            ModeIds.BULLET,
            ModeIds.BLITZ,
            ModeIds.RAPID,
            ModeIds.CHESS960,
            ModeIds.DAILY,
            ModeIds.PUZZLE,
        ].map((modeId) => ({
            params: { modeId: modeId.toString() },
            locale: "ru",
        }))
        : [];
    return {
        // League tables are user-specific utility pages. Generate a requested
        // locale once, but retain Russian HTML for the static Yandex fallback.
        paths: russianFallbackPaths,
        fallback: "blocking",
    };
}
const getStaticProps = async ({ params }) => {
    const { modeId } = params;
    return {
        props: { modeId },
    };
};

    async function __Next_Translate__getStaticProps__1a0fc0d5483__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/leagues/[modeId]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a0fc0d5483__ as getStaticProps }
  